<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('contact.editor')}}</span>
  </template>

  <v-form ref="form" v-model="validContact" lazy-validation>
    <name-text-field v-model="nameText" autofocus></name-text-field>
    <v-text-field box v-model="emailText" :rules="rulesEmail" :label="$t('contact.email')" required></v-text-field>
    <v-text-field box v-model="smsText" :rules="rulesSms" :label="$t('contact.sms')"></v-text-field>
  </v-form>

  <template slot="actions">
    <v-btn color="accent" flat @click="removeContact" v-if="contact" :loading="deleting">{{ $t('contact.delete') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn color="primary" flat :disabled="!validContact" @click="saveContact" :loading="saving">{{ $t('contact.save') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import NameTextField from '@/components/utils/NameTextField'

let regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
let regexPhone = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/;

export default {
  name: 'ContactEditor',
  mixins: [UserAuth],
  components: {
    'standard-dialog': Dialog,
    'name-text-field': NameTextField
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    contact: {
      type: Object
    }
  },
  data() {
    return {
      nameText: null,
      emailText: null,
      smsText: null,
      validContact: false,
      rulesEmail: [v => !!v || regexEmail.test(v) || this.$t('contact.email_invalid')],
      rulesSms: [v => !!(!v || regexPhone.test(v)) || this.$t('contact.sms_invalid')],
      saving: false,
      deleting: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    contactKey() {
      if (this.contact) return this.contact.key;
      if (this.emailText) return Buffer.from(this.emailText).toString('base64');
    }
  },
  methods: {
    removeContact() {
      this.deleting = true;
      this.$db.ref('userContact').child(this.userId).child(this.contactKey)
        .remove()
        .then(() => {
          this.visible = false;
        })
        .catch(err => {
          this.$emit('toast', err);
          this.deleting = false;
        });
    },
    saveContact() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      let data = {
        name: this.nameText
      };
      if (this.emailText) data.email = this.emailText;
      if (this.smsText) data.sms = this.smsText;
      this.$db.ref('userContact').child(this.userId).child(this.contactKey)
        .set(data)
        .then(() => {
          this.visible = false;
        })
        .catch(err => {
          this.$emit('toast', err);
          this.saving = false;
        });
    }
  },
  mounted() {
    this.$refs.form.reset();
    this.nameText = (this.contact || {}).name;
    this.emailText = (this.contact || {}).email;
    this.smsText = (this.contact || {}).sms;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactEditorDialog.vue